export default __webpack_public_path__ + "static/media/7.1eedd481.png";